import {
  StyledBodyText,
  StyledErrorContainer,
  StyledIllustration,
  StyledTitleText,
  StyledButtonContainer,
  StyledContent,
} from './styled';
import {TermDescriptor, useGlobalization} from '@planday-corp/globalization';
import ButtonLink from '@planday-corp/ui/actions/NavLinks/ButtonLink';
import Label from '@planday-corp/ui/types/Label';
import React from 'react';

export interface ErrorScreenProps {
  redirectPath?: string | undefined;
  illustrationSvg: string;
  title: Label;
  body: Label;
  buttonLabel: TermDescriptor;
}

export default function ErrorScreen({
  redirectPath,
  illustrationSvg,
  title,
  body,
  buttonLabel,
}: ErrorScreenProps) {
  const {i18n} = useGlobalization();
  return (
    <StyledErrorContainer>
      <StyledContent>
        <StyledIllustration src={illustrationSvg} role="presentation" />
        <StyledTitleText size="title1" element="h1" value={title} />
        <StyledBodyText size="body" element="p" value={body} />

        {redirectPath && (
          <StyledButtonContainer>
            <ButtonLink type="primary" href={redirectPath}>
              {i18n.t(buttonLabel)}
            </ButtonLink>
          </StyledButtonContainer>
        )}
      </StyledContent>
    </StyledErrorContainer>
  );
}
